"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.WETH = exports.currencyEquals = exports.Token = void 0;
const tiny_invariant_1 = __importDefault(require("tiny-invariant"));
const constants_1 = require("../constants");
const utils_1 = require("../utils");
const currency_1 = require("./currency");
/**
 * Represents an ERC20 token with a unique address and some metadata.
 */
class Token extends currency_1.Currency {
    constructor(chainId, address, decimals, symbol, name) {
        super(decimals, symbol, name);
        this.chainId = chainId;
        this.address = (0, utils_1.validateAndParseAddress)(address);
    }
    /**
     * Returns true if the two tokens are equivalent, i.e. have the same chainId and address.
     * @param other other token to compare
     */
    equals(other) {
        // short circuit on reference equality
        if (this === other) {
            return true;
        }
        return this.chainId === other.chainId && this.address === other.address;
    }
    /**
     * Returns true if the address of this token sorts before the address of the other token
     * @param other other token to compare
     * @throws if the tokens have the same address
     * @throws if the tokens are on different chains
     */
    sortsBefore(other) {
        (0, tiny_invariant_1.default)(this.chainId === other.chainId, "CHAIN_IDS");
        (0, tiny_invariant_1.default)(this.address !== other.address, "ADDRESSES");
        return this.address.toLowerCase() < other.address.toLowerCase();
    }
}
exports.Token = Token;
/**
 * Compares two currencies for equality
 */
function currencyEquals(currencyA, currencyB) {
    if (currencyA instanceof Token && currencyB instanceof Token) {
        return currencyA.equals(currencyB);
    }
    else if (currencyA instanceof Token) {
        return false;
    }
    else if (currencyB instanceof Token) {
        return false;
    }
    else {
        return currencyA === currencyB;
    }
}
exports.currencyEquals = currencyEquals;
exports.WETH = {
    [constants_1.ChainId.MAINNET]: new Token(constants_1.ChainId.MAINNET, "0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2", 18, "WETH", "Wrapped Ether"),
    [constants_1.ChainId.ROPSTEN]: new Token(constants_1.ChainId.ROPSTEN, "0xc778417E063141139Fce010982780140Aa0cD5Ab", 18, "WETH", "Wrapped Ether"),
    [constants_1.ChainId.RINKEBY]: new Token(constants_1.ChainId.RINKEBY, "0xc778417E063141139Fce010982780140Aa0cD5Ab", 18, "WETH", "Wrapped Ether"),
    [constants_1.ChainId.GÖRLI]: new Token(constants_1.ChainId.GÖRLI, "0xB4FBF271143F4FBf7B91A5ded31805e42b2208d6", 18, "WETH", "Wrapped Ether"),
    [constants_1.ChainId.KOVAN]: new Token(constants_1.ChainId.KOVAN, "0xd0A1E359811322d97991E03f863a0C30C2cF029C", 18, "WETH", "Wrapped Ether"),
    [56]: new Token(56, "0xbb4CdB9CBd36B01bD1cBaEBF2De08d9173bc095c", 18, "WBNB", "Wrapped BNB"),
    [128]: new Token(128, "0x5545153CCFcA01fbd7Dd11C0b23ba694D9509A6F", 18, "WHT", "Wrapped Huobi Token")
};
